<template>
  <nav
    class="sli-module-tabs"
    aria-label="أقسام الحصر"
  >
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      class="sli-module-tab"
      :class="{ active: tab.key === value }"
      @click="$emit('input', tab.key)"
    >
      <span class="menu-title">{{ tab.title }}</span>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'SliModuleTabs',
  props: {
    tabs: { type: Array, default: () => [] },
    value: { type: String, default: '' },
  },
}
</script>

<style scoped>
.sli-module-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0 12px;
}
.sli-module-tab {
  appearance: none;
  border: 0;
  background: transparent;
  color: #041c38;
  padding: 10px 16px;
  line-height: 1.45;
  border-radius: 4px;
  font-weight: 400;
  cursor: pointer;
  margin: 0;
}
.sli-module-tab .menu-title {
  display: inline-block;
}
.sli-module-tab.active {
  z-index: 1;
  background: linear-gradient(118deg, #06284d, rgba(6, 40, 77, 0.7));
  box-shadow: 0 0 10px 1px rgba(6, 40, 77, 0.7);
  color: #fff;
  font-weight: 400;
  border-radius: 4px;
}
.sli-module-tab.active::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 1.1em;
  background: #5cc10b;
  border-radius: 2px;
  margin-left: 8px;
  vertical-align: -0.15em;
}
</style>
